/*eslint-disable */
import styled from 'styled-components';

export const Loading_Container = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	img {
		width: 300px;
		height: 300px;
	}
`;
